import { Gender } from '../../../types/character';
import './GenderSelector.css';

interface GenderSelectorProps {
  selectedGender: Gender;
  onChange: (gender: Gender) => void;
}

export function GenderSelector({ selectedGender, onChange }: GenderSelectorProps) {
  return (
    <div className="gender-selector">
      <label className="selector-label">Gender</label>
      <div className="gender-options">
        <button
          type="button"
          className={`gender-option ${selectedGender === 'male' ? 'selected' : ''}`}
          onClick={() => onChange('male')}
        >
          <span className="gender-icon">&#9794;</span>
          <span className="gender-text">Male</span>
        </button>
        <button
          type="button"
          className={`gender-option ${selectedGender === 'female' ? 'selected' : ''}`}
          onClick={() => onChange('female')}
        >
          <span className="gender-icon">&#9792;</span>
          <span className="gender-text">Female</span>
        </button>
      </div>
    </div>
  );
}

export default GenderSelector;
